import { api } from './api'

export interface GeneratePagaleveCheckoutResponse {
  checkout_url: string
}

export const paymentService = {
  async generatePagaleveCheckout(orderId: number, address?: Record<string, any>): Promise<string> {
    const payload = {
      order_id: orderId,
      payment_gateway: 'pagaleve',
      flow_type: 'representative',
      callback_base_url: window.location.origin,
      payments: [],
      address: address ?? {},
    }
    const { data } = await api.post(`/payments/charges`, payload)
    const url = data?.data?.checkout_url
    if (!url) throw new Error('checkout_url inválida na resposta da API')
    return url
  },
  async checkOrderStatusByUuid(uuid: string) {
    const { data } = await api.get(`/order_b2b_status/${uuid}`)
    return data
  },
}

